import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { getPage } from "ab-api-queries";
import ABForgotPassword from "ab-forgot-password";

const ForgotPassword = () => {
  const { i18n } = useTranslation("common");
  return <ABForgotPassword i18n={i18n} />;
};

export async function getServerSideProps({ locale }) {
  const data = await getPage("/login");
  const translations = await serverSideTranslations(locale, ["common"]);
  return {
    props: {
      seo: data?.nodeByUri?.seo || {},
      content: data?.nodeByUri?.contenidoFlexible?.modulos || [],
      footer: data?.headerFooter?.footer,
      menu: data?.headerFooter?.menu,
      translations: data?.nodeByUri?.translations,
      language: data?.nodeByUri?.language,
      ...translations,
    }, // will be passed to the page component as props
    notFound: locale !== "en",
  };
}

export default ForgotPassword;
